import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgExternalLinkIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 25,
	height: 26,
	viewBox: "0 0 25 26",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M24 0H15C14.4477 0 14 0.447716 14 1C14 1.55229 14.4477 2 15 2L21.5858 2L7.29289 16.2929C6.90237 16.6834 6.90237 17.3166 7.29289 17.7071C7.68342 18.0976 8.31658 18.0976 8.70711 17.7071L23 3.41421V10C23 10.5523 23.4477 11 24 11C24.5523 11 25 10.5523 25 10V1C25 0.447716 24.5523 0 24 0ZM2 4H13.3137L11.3137 6H2L2 24H20V14.2843L22 12.2843V24C22 25.1046 21.1046 26 20 26H2C0.89543 26 0 25.1046 0 24V6C0 4.89543 0.895431 4 2 4Z",
		fill: "white"
	})
});
export default SvgExternalLinkIcon;
